import { Pin } from 'lucide-react';
import { GroupChannel } from '@sendbird/chat/groupChannel';
import {
  FileMessage,
  MultipleFilesMessage,
  UserMessage,
} from '@sendbird/chat/message';
import { OpenChannel } from '@sendbird/chat/openChannel';
import {
  MenuItem,
  useMessageMenuContext,
} from '@sendbird/uikit-react/ui/MessageMenu';
import { useNotify, useTranslate } from 'ra-core';
import { MAX_PINNED_MESSAGES } from '../../../../api/hooks/sendbird/constants';
import { usePinUnpinMessage } from '../../../../api/hooks/sendbird/usePinUnpinMessage';
import { type SendableMessage } from '../../ForwardMessageProvider';
import { MenuItemBoxContainer } from './MessageCustomMenu';

type PinUnpinMenuItemProps = {
  channel: GroupChannel | OpenChannel;
  message: SendableMessage;
  isPinned: boolean | undefined;
};

export const PinUnpinMenuItem: React.FC<PinUnpinMenuItemProps> = ({
  channel,
  message,
  isPinned,
}) => {
  const notify = useNotify();
  const translate = useTranslate();
  const menuContext = useMessageMenuContext();
  const { mutate, isPending } = usePinUnpinMessage();

  const onPinOrUnPin = ({
    channel,
    message,
    isPinned,
  }: {
    channel: GroupChannel | OpenChannel | null;
    message: UserMessage | FileMessage | MultipleFilesMessage;
    isPinned: boolean;
  }) => {
    if (!channel) return;
    if (channel.pinnedMessageIds.length >= MAX_PINNED_MESSAGES && !isPinned) {
      notify(
        translate('chat.pinMessageMax', {
          maxPinnedMessages: MAX_PINNED_MESSAGES,
        }),
        { type: 'error', autoHideDuration: 5000 }
      );
      return;
    }

    mutate({ channel, message, isPinned });
    menuContext.hideMenu();
  };

  return (
    <MenuItem
      onClick={() => onPinOrUnPin({ channel, message, isPinned: !!isPinned })}
      disabled={isPending}
    >
      <MenuItemBoxContainer>
        <Pin />
        <span>{translate(isPinned ? 'chat.unpin' : 'chat.pin')}</span>
      </MenuItemBoxContainer>
    </MenuItem>
  );
};
